import React from 'react';
import MessageListAndToolsContainer from '@app/components/presentational/MessagingResponsive/MessageListAndTools/MessageListAndToolsContainer';
import { Dialog, DialogContent } from '@mui/material';
import { useTheme } from '@ublend-npm/aulaui-core';

const ConversationView = (props) => {
  const { isConversationDialogOpen, handleConversationDialogClose } = props;
  const { palette } = useTheme();

  return (
    <Dialog
      open={isConversationDialogOpen}
      onClose={handleConversationDialogClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="conversation-dialog-title"
      aria-describedby="conversation-dialog-description"
      sx={{
        '& .MuiDialogContent-root': {
          padding: 0,
        },
        '& .MuiDialog-paper': {
          backgroundColor: palette.background.paper,
          color: palette.text.primary,
        },
        '& #message-container': {
          padding: 2,
        },
      }}
    >
      <DialogContent>
        <MessageListAndToolsContainer />
      </DialogContent>
    </Dialog>
  );
};

export default ConversationView;
